import dayjs from "dayjs";

export const fmtDate = (value) => value && dayjs(value).format("DD.MM.YYYY")

export const ftmPrice = value => {
  if (!value) return value;
  const formatted = value.toFixed(2);
  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}